module.exports = __webpack_public_path__ + "img/person-purple.f5ac3a38.png";